module.exports = __webpack_public_path__ + "static/media/download-action-icon.a61adee3.svg";